// extracted by mini-css-extract-plugin
module.exports = {"contentSection":"GS_Section1_contentSection__2_Nss","customContainer":"GS_Section1_customContainer__1_Uk5"};